import React, { useEffect } from 'react';
export function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-589">
      <main className="py-12" data-id="element-590">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-591">
          <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-8 md:p-12 lg:p-16" data-id="element-592">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 pb-8 border-b border-slate-100" data-id="element-593">
              Política de Privacidad y Protección de Datos
            </h1>

            <div className="text-slate-600 space-y-8 text-lg" data-id="element-594">
              <section data-id="element-595">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-596">
                  1. INTRODUCCIÓN
                </h3>
                <p className="leading-relaxed" data-id="element-597">
                  En TicketMaestro valoramos y respetamos la privacidad de
                  nuestros usuarios. Esta Política de Privacidad describe cómo
                  recopilamos, utilizamos, almacenamos y protegemos los datos
                  personales que usted nos proporciona al utilizar nuestros
                  sitios, APPs, terminales de autoatención u otros sistemas o
                  canales de comunicación.
                </p>
              </section>

              <section data-id="element-598">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-599">
                  2. RESPONSABLE DEL TRATAMIENTO
                </h3>
                <ul className="space-y-2 list-disc pl-5" data-id="element-600">
                  <li data-id="element-601">
                    <strong className="text-slate-800" data-id="element-602">
                      Nombre de la entidad:
                    </strong>{' '}
                    TicketMaestro SAS
                  </li>
                  <li data-id="element-603">
                    <strong className="text-slate-800" data-id="element-604">Dirección Legal:</strong>{' '}
                    Edificio The Point, Oficina 1803, Puerto Santa Ana,
                    Guayaquil, Ecuador.
                  </li>
                  <li data-id="element-605">
                    <strong className="text-slate-800" data-id="element-606">
                      Correo electrónico de contacto:
                    </strong>{' '}
                    contacto@ticketmaestro.net.
                  </li>
                </ul>
              </section>

              <section data-id="element-607">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-608">
                  3. DATOS PERSONALES QUE RECOPILAMOS
                </h3>
                <p className="mb-4" data-id="element-609">
                  Podemos recopilar los siguientes datos personales cuando
                  navegas o interactúas con nuestro sitio web u otros canales:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-610">
                  <li data-id="element-611">Nombres y apellidos</li>
                  <li data-id="element-612">Número de Cédula</li>
                  <li data-id="element-613">Correo electrónico</li>
                  <li data-id="element-614">Número de teléfono</li>
                  <li data-id="element-615">
                    Dirección IP y datos de navegación (cookies, ubicación, tipo
                    de navegador)
                  </li>
                  <li data-id="element-616">
                    Información proporcionada mediante formularios de contacto o
                    suscripción
                  </li>
                </ul>
              </section>

              <section data-id="element-617">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-618">
                  4. FINALIDAD DEL TRATAMIENTO
                </h3>
                <p className="mb-4" data-id="element-619">
                  Recopilamos tus datos con las siguientes finalidades:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-620">
                  <li data-id="element-621">
                    Enviar información institucional, boletines, eventos,
                    productos y servicios
                  </li>
                  <li data-id="element-622">
                    Atender consultas o solicitudes realizadas a través de
                    formularios de contacto
                  </li>
                  <li data-id="element-623">Gestionar inscripciones a eventos o programas</li>
                  <li data-id="element-624">
                    Gestionar promociones, beneficios, sistemas de fidelización
                    y otras actividades de marketing
                  </li>
                  <li data-id="element-625">
                    Realizar análisis estadísticos de navegación (uso de
                    cookies)
                  </li>
                  <li data-id="element-626">Cumplir con obligaciones legales y regulatorias</li>
                </ul>
              </section>

              <section data-id="element-627">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-628">
                  5. LEGITIMACIÓN PARA EL TRATAMIENTO
                </h3>
                <p className="mb-4" data-id="element-629">
                  El tratamiento de tus datos se realiza con base en:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-630">
                  <li data-id="element-631">Tu consentimiento expreso</li>
                  <li data-id="element-632">
                    El interés legítimo de TicketMaestro para cumplir su misión
                    institucional
                  </li>
                  <li data-id="element-633">
                    El cumplimiento de obligaciones legales, según la normativa
                    ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                    Personales – LOPDP)
                  </li>
                </ul>
              </section>

              <section data-id="element-634">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-635">
                  6. DESTINATARIOS DE LOS DATOS
                </h3>
                <p className="mb-4" data-id="element-636">
                  Tus datos personales no serán compartidos con terceros, salvo
                  que:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-637">
                  <li data-id="element-638">Tengamos tu consentimiento previo</li>
                  <li data-id="element-639">
                    Sea requerido por autoridad competente conforme a la ley
                  </li>
                  <li data-id="element-640">
                    Se usen herramientas tecnológicas de terceros (por ejemplo,
                    para envío de newsletters, CRM o formularios) con contratos
                    que garantizan la protección de tus datos
                  </li>
                </ul>
              </section>

              <section data-id="element-641">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-642">
                  7. DERECHOS DEL TITULAR DE LOS DATOS
                </h3>
                <p className="mb-4" data-id="element-643">Tienes derecho a:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-644">
                  <li data-id="element-645">Acceder a tus datos personales</li>
                  <li data-id="element-646">Rectificar datos inexactos o incompletos</li>
                  <li data-id="element-647">Eliminar tus datos (cuando proceda)</li>
                  <li data-id="element-648">Oponerte al tratamiento</li>
                  <li data-id="element-649">Solicitar la portabilidad de tus datos</li>
                  <li data-id="element-650">Revocar el consentimiento en cualquier momento</li>
                </ul>
                <p data-id="element-651">
                  Puedes ejercer estos derechos escribiéndonos a{' '}
                  <a href="mailto:protecciondatos@ticketmaestro.net" className="text-indigo-600 hover:underline font-medium" data-id="element-652">
                    protecciondatos@ticketmaestro.net
                  </a>
                </p>
              </section>

              <section data-id="element-653">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-654">
                  8. USO DE COOKIES
                </h3>
                <p className="leading-relaxed" data-id="element-655">
                  Nuestros sitios utilizan cookies propias y de terceros para
                  mejorar la experiencia de navegación y análisis del tráfico.
                  Puedes aceptar, configurar o rechazar el uso de cookies desde
                  el banner de consentimiento al ingresar al sitio.
                </p>
              </section>

              <section data-id="element-656">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-657">
                  9. SEGURIDAD DE LA INFORMACIÓN
                </h3>
                <p className="leading-relaxed" data-id="element-658">
                  TicketMaestro aplica medidas de seguridad técnicas y
                  organizativas adecuadas para proteger tus datos personales
                  contra accesos no autorizados, pérdida, destrucción o
                  alteración.
                </p>
              </section>

              <section data-id="element-659">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-660">
                  10. CONSERVACIÓN DE LOS DATOS
                </h3>
                <p className="leading-relaxed" data-id="element-661">
                  Tus datos serán conservados solo durante el tiempo necesario
                  para cumplir con la finalidad para la que fueron recopilados o
                  mientras exista una relación institucional o contractual.
                  Posteriormente serán eliminados o anonimizados, según
                  corresponda.
                </p>
              </section>

              <section data-id="element-662">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-663">
                  11. CAMBIOS A ESTA POLÍTICA
                </h3>
                <p className="leading-relaxed" data-id="element-664">
                  Nos reservamos el derecho de modificar esta Política de
                  Privacidad en cualquier momento. Cualquier cambio será
                  publicado con la fecha de actualización correspondiente.
                </p>
              </section>

              <section data-id="element-665">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-666">
                  12. AUTORIDAD DE CONTROL
                </h3>
                <p className="leading-relaxed" data-id="element-667">
                  Si consideras que tus derechos no han sido respetados, puedes
                  presentar un reclamo ante la Autoridad de Protección de Datos
                  Personales de Ecuador, la Superintendencia de Protección de
                  Datos Personales.
                </p>
              </section>

              <section data-id="element-668">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-669">
                  13. VIGENCIA
                </h3>
                <p className="leading-relaxed" data-id="element-670">
                  La vigencia de estas Políticas de Privacidad y Protección de
                  Datos es desde el 21 de noviembre de 2025 y permanecerá
                  vigente hasta que exista una nueva versión que la reemplace.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>;
}